export const checklistColumns = [
    {
      Header: 'Id',
      accessor: 'id',
    },
    {
      Header: 'Check Point',
      accessor: 'checkPoint',
    },
    {
      Header: 'Type',
      accessor: 'type',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
    }
  ];

  export const checklistTableData = [
    {   
        id:'01',
        checkPoint:'Washing',
        type:'Laundry',
    },
    {   
        id:'02',
        checkPoint:'Dry-Cleaning',
        type:'Laundry',
    },
    {   
        id:'03',
        checkPoint:'Towels',
        type:'Laundry',
    },
    {   
        id:'04',
        checkPoint:'Ironing',
        type:'Laundry',
    },
    {   
        id:'05',
        checkPoint:'Floor Cleaning',
        type:'House Keeper',
    },
    {   
      id:'06',
      checkPoint:'Sanitize the toilet',
      type:'House Keeper',
    },
    {   
      id:'07',
      checkPoint:'Dustbins and replace',
      type:'House Keeper',
    },
    {   
      id:'08',
      checkPoint:'Wipe down countertops',
      type:'House Keeper',
    },
]